import React, {useState} from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";
import ExpandInfo from "./ExpandInfo";

const Pas1 = () => {

  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "25rem" : "21rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              Client
            </Typography>
          </div>
          <div></div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Informarea preliminară
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Informații generale privind condițiile și posibilitățile de
            realizare a racordării la rețea a locului de consum și/sau de
            producere:
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Personal, la Centrele de Relații cu Utilizatorii;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            E-mail, la adresa: office@distributie-energie.ro;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Poștă/curier;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Canale de comunicare electronică (portal).
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a href="./Nota-informare-clienti-DEER-final.doc" style={{ color: "#0D6D92" }}>
              Nota de informare generală privind prelucrarea datelor cu caracter
              personal
            </a>
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            3 zile calendaristice de la înregistrarea cererii scrise
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "33rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
        <ExpandInfo/>
      </div>
    </div>
  );
};
export default Pas1;
